import LeftSider from './LeftSider/index';
import RightPanels from './RightPanels';

export {
  LeftSider,
  RightPanels,
};



// WEBPACK FOOTER //
// ./src/views/ReportSetup/components/index.js